var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.SkuPicker,{ref:"skuRef",attrs:{"product-id":_setup.id},on:{"back":_setup.onBack}})
}
var staticRenderFns = []

export { render, staticRenderFns }